import bigOnBreakfast from '../img/BigOnBreakfast2025.png';
import CountrySteakEggsSqure from '../img/Breakfast/BreakfastCombos/CountrySteakEggsSqure2025.png';
import CountrySteakEggsRect from '../img/Breakfast/BreakfastCombos/CountrySteakEggsRect2025.png';

import LoadedChapatiComboSqure from '../img/Breakfast/BreakfastCombos/LoadedChapatiComboSqure2025.png';
import LoadedChapatiComboRect from '../img/Breakfast/BreakfastCombos/LoadedChapatiComboRect2025.png';

import CJChickenandWaffleSqure2025 from '../img/Breakfast/BreakfastCombos/CJ-ChickenandWaffleSqure2025.png';
import CJChickenandWaffleRect2025 from '../img/Breakfast/BreakfastCombos/CJ-ChickenandWaffleRect2025.png';

import FriedChickenWafflesBenedictSquare from '../img/Breakfast/BreakfastCombos/FriedChickenWafflesBenedictSquare.jpeg';
import FriedChickenWafflesBenedictRect from '../img/Breakfast/BreakfastCombos/FriedChickenWafflesBenedictRect.jpeg';

import BreakfastSamplerSquare from '../img/Breakfast/BreakfastCombos/BreakfastPancakeSamplerSqure2025.png';
import BreakfastSamplerRect from '../img/Breakfast/BreakfastCombos/BreakfastPancakeSamplerRect2025.png';

import GrilledchickenSqaure from '../img/Breakfast/BreakfastCombos/GrilledChickenEggsSqure2025.png';
import GrilledchickenRect from '../img/Breakfast/BreakfastCombos/GrilledChickenEggsRect2025.png';
import OmeletteComboSquare from '../img/Breakfast/BreakfastCombos/OmeletteComboSqure2025.png';

import OmeletteComboRect from '../img/Breakfast/BreakfastCombos/OmeletteComboRect2025.png';
import FitBreakfastSquare from '../img/Breakfast/BreakfastCombos/1.png';
import FitBreakfastReact from '../img/Breakfast/BreakfastCombos/1Rect.png';

import HouseBreakfastSquare from '../img/Breakfast/BreakfastCombos/cjs-HouseBreakfastsqure2025.png';
import HouseBreakfastReact from '../img/Breakfast/BreakfastCombos/cjs-HouseBreakfastRect2025.png';

import ChickenEggWrapComboSquare from '../img/Breakfast/BreakfastCombos/ChickenEggWrapComboSqure2025.png';
import ChickenEggWrapComboRect from '../img/Breakfast/BreakfastCombos/ChickenEggWrapComboRect2025.png';
import MonteCristoSandwichSquare from '../img/Breakfast/BreakfastCombos/CJsMonteCristoSandwichSqure2025.png';
import MonteCristoSandwichRect from '../img/Breakfast/BreakfastCombos/CJMonteCristoSandwichRect2025.png';
import ChickenSaladFilledCroissantComboSquare from '../img/Breakfast/BreakfastCombos/ChickenSaladFilledCroissantComboSqure2025.png';
import ChickenSaladFilledCroissantComboReact from '../img/Breakfast/BreakfastCombos/ChickenSaladFilledCroissantComboRect2025.png';

//new Addition 2025
import RoastedChickenEggBreakfastComboSqure from '../img/Breakfast/BreakfastCombos/RoastedChickenEggBreakfastComboSqure2025.png';
import RoastedChickenEggBreakfastComboRect from '../img/Breakfast/BreakfastCombos/RoastedChickenEggBreakfastComboRect2025.png';

//new Addition 2025
import SteakAndEggsBreakfastSqure from '../img/Breakfast/BreakfastCombos/SteakandEggsBreakfastSqure2025.png';
import SteakAndEggsBreakfastRect from '../img/Breakfast/BreakfastCombos/SteakandEggsBreakfastRect2025.png';

//new Addition 2025
import SalmonEggsAvocadoBenedictSqure from '../img/Breakfast/BreakfastCombos/SalmonEggesAndAvocodoSqure2025.png';
import SalmonEggsAvocadoBenedictRect from '../img/Breakfast/BreakfastCombos/SalmonEggesAndAvocodoRect2025.png';



import SpanishOmeletteSquare from '../img/Breakfast/DesignerOmeletters/SpanishOmeletteSqure2025.png';
import SpanishOmeletteRect from '../img/Breakfast/DesignerOmeletters/SpanishOmeletteRect2025.png';
import SpinachMushroomOmeletteSquare from '../img/Breakfast/DesignerOmeletters/SpinachMushroomOmeletteSquare.png';
import SpinachMushroomOmeletteRect from '../img/Breakfast/DesignerOmeletters/SpinachMushroomOmeletteRect.png';
import ChickenFajitaOmeletteSquare from '../img/Breakfast/DesignerOmeletters/ChickenFajitaOmeletteSquare.png';
import ChickenFajitaOmeletteRect from '../img/Breakfast/DesignerOmeletters/ChickenFajitaOmeletteRect.png';

//image updated Waffle & Pancakes 2025
import BelgianWaffleSquare from '../img/Breakfast/WafflePancakes/BelgianWaffleSquare2025.png';
import BelgianWaffleRect from '../img/Breakfast/WafflePancakes/BelgianWaffleRect2025.png';
import StrawberryBananaWaffleSquare from '../img/Breakfast/WafflePancakes/StrawberryBananaWaffleSquare2025.png';
import StrawberryBananaWaffleRect from '../img/Breakfast/WafflePancakes/StrawberryBananaWaffleRect2025.png';
import OriginalButtermilkPancakeSquare from '../img/Breakfast/WafflePancakes/OriginalButtermilkPancakeSquare2025.png';
import OriginalButtermilkPancakeRect from '../img/Breakfast/WafflePancakes/OriginalButtermilkPancakeRect2025.png';
import StrawberryBananaPancakeSquare from '../img/Breakfast/WafflePancakes/StrawberryBananaPancakeSquare2025.png';
import StrawberryBananaPancakeRect from '../img/Breakfast/WafflePancakes/StrawberryBananaPancakeRect2025.png';


import bananaMuffin from '../img/Breakfast/AmazingMuffins/BananaMuffinSqure2025.png';
import bananaMuffinRect from '../img/DecadentDessert/bananaMuffinRect.png';

import chocolateChipMuffinRect from '../img/Breakfast/AmazingMuffins/ChocolateChipMuffinSqure2025.png';
import chocolateChipMuffin from '../img/Breakfast/AmazingMuffins/ChocolateChipMuffinSqure2025.png';

import vanillaMuffinRect from '../img/DecadentDessert/vanillaMuffinRect.png';


import chocolateMuffinrect from '../img/DecadentDessert/chocolateMuffinrect.png';
import chocolateMuffin from '../img/Breakfast/AmazingMuffins/ChocolateMuffinSqure2025.png';

import vanillaMuffin from '../img/Breakfast/AmazingMuffins/VanillaMuffinSqure2025.png';

import plainCroissand from '../img/Breakfast/BakedFreshPastries/PlainCroissantSqure2025.png';
import plainCroissandRect from '../img/Breakfast/BakedFreshPastries/PlainCroissantRect2025.png';

import almondCroissant from '../img/Breakfast/BakedFreshPastries/AlmondCroissantSqure2025.png';
import almondCroissantRect from '../img/Breakfast/BakedFreshPastries/AlmondCroissantRect2025.png';

import chocolateTwist from '../img/Breakfast/BakedFreshPastries/ChocolateTwistSqure2025.png';
import chocolateTwistRect from '../img/Breakfast/BakedFreshPastries/ChocolateTwistRect2025.png';

import CinnamonCroissant from '../img/Breakfast/BakedFreshPastries/CinnamonCroissantSqure2025.png';
import CinnamonCroissantRect from '../img/Breakfast/BakedFreshPastries/CinnamonCroissantRect2025.png';

import samosas from '../img/Breakfast/BakedFreshPastries/BeefSamosasSqure2025.png';
import samosasRect from '../img/Breakfast/BakedFreshPastries/BeefSamosasSqure2025.png';

import VegetableSamosas from '../img/Breakfast/BakedFreshPastries/VegetableSamosasSqure2025.png';
import VegetableSamosasRect from '../img/Breakfast/BakedFreshPastries/VegetableSamosasRect2025.png';

import vegetableSpringRollsRect from '../img/Meals/vegetableSpringRollsRect.png';

import chickenSpringRollsRect from '../img/Meals/chickenSpringRollsRect.png';

import vegetableSpringRolls from '../img/Meals/vegetableSpringRolls.png';
import chickenSpringRolls from '../img/Meals/chickenSpringRolls.png';
import ChickenSamosas from '../img/Breakfast/FruitfulMornings/ChickenSamosasNew.png';
import ChickenSamosasRect from '../img/Breakfast/FruitfulMornings/ChickenSamosasNewRectanglerect.png';

import FruitSaladRect from '../img/DecadentDessert/FruitSaladRect.png';
import FruitSalad from '../cjs-imgs/FruitSalad.svg';


import TropicalBreakfast from '../img/Breakfast/FruitfulMornings/TropicalBreakfastSqure2025.png';
import TropicalBreakfastRect from '../img/Breakfast/FruitfulMornings/TropicalBreakfastRect2025.png';

import OatmealBreakfastSqure from '../img/Breakfast/FruitfulMornings/OatmealBreakfastSqure.png';
import OatmealBreakfastRect from '../img/Breakfast/FruitfulMornings/OatmealBreakfastRect.png';

import FruitPlatter from '../img/Breakfast/FruitfulMornings/TropicalBreakfast.png';
import FruitPlatterRect from '../img/Breakfast/FruitfulMornings/FruitPlatterRect.png';

import SingleFriedEggRectanle from '../img/Breakfast/Extras/SingleFriedEggRectangle.png';
import SingleFriedEgg from '../img/Breakfast/Extras/SquareSingleFriedEgg.png';

import PairofSausages from '../img/Breakfast/Extras/PairofSausages.png';
import PairofSausagesRect from '../img/Breakfast/Extras/PairofSausagesRect.png';

import HomeFries from '../img/Breakfast/Extras/HomeFries.png';
import HomeFriesRect from '../img/Breakfast/Extras/HomeFriesRect.png';

import FruitBowl from '../img/Breakfast/Extras/FruitBowl.png';
import FruitBowlRect from '../img/Breakfast/Extras/FruitBowlRect.png';

import BakedBeans from '../img/Breakfast/Extras/BakedBeans.png';
import BakedBeansRect from '../img/Breakfast/Extras/BakedBeansRect.png';

import FriedPlantain from '../img/Breakfast/Extras/FriedPlantain.png';
import FriedPlantainRect from '../img/Breakfast/Extras/FriedPlantainRect.png';

import Toast from '../img/Breakfast/Extras/Toast.png';
import ToastRect from '../img/Breakfast/Extras/ToastRect.png';

import Avocado from '../img/Breakfast/Extras/avocado-squre.png';
import AvocadoRect from '../img/Breakfast/Extras/avocado-react.png';

import Mushrooms from '../img/Breakfast/Extras/extra-mushroom-squre.png';
import MushroomsRect from '../img/Breakfast/Extras/extra-mushroom-rect.png';

import BeefMacon from '../img/Breakfast/Extras/beef-macon-square.png.png';
import BeefMaconRect from '../img/Breakfast/Extras/beef-macon-square.png.png';

import chickenPie from '../img/Breakfast/Extras/chickenPie.png';
import chickenPieRect from '../img/Breakfast/Extras/chickenPieRect.png';

import kiddieSampleCombo from '../img/Breakfast/RangerBreakfast/kiddieSampleCombo.png';
import kiddieSampleComboRect from '../img/Breakfast/RangerBreakfast/kiddieSampleComboRect.png';

import kiddieChapatiCombo from '../img/Breakfast/RangerBreakfast/kiddieChapatiCombo.png';
import kiddieChapatiComboRect from '../img/Breakfast/RangerBreakfast/kiddieChapatiComboRect.png';

import chapati from '../img/Meals/chapati.png';
import chapatiRect from '../img/Meals/chapatiRect.png';

import roastedPlantainRect from '../img/Meals/roastedPlantainRect.png';
import roastedPlantain from '../img/Meals/roastedPlantain.png';

import KiddiePancake from '../img/Meals/kiddiePancake.png';
import KiddiePancakeRect from '../img/Meals/kiddiePancakeRect.png';



const BigOnBreakfast =
{
    "ImageURL": bigOnBreakfast,
    "Name": "Big On Breakfast",
    "OpenTime": "06:00 AM - 11:30 AM",
    "Status": "Opened",
    "type": [
        //Country Steak & Eggs 2025 image updated
        {
            "ImageURL": CountrySteakEggsSqure,
            "Name": "Country Steak & Eggs",
            "category": "Breakfast Combos",
            "dec": "Breaded Beef Steak smothered in country gravy, two eggs and pancakes or chapatis. Served with home fries.",
            "KES": 1100,
            "RectImageURL": CountrySteakEggsRect,
            "Upgrades": [
                { name: "ADD Fruit bowl", price: 180 },
                { name: "ADD Toast OR Chapati", price: 180 },
                { name: "Substitute home fries with Plantain", price: 330 },
                { name: "Substitute home fries with steamed vegetables", price: 330 },
                { name: "Substitute your juice with orange juice", price: 180 }
            ]
        },
        //Loaded Chapati Combo

        {
            "ImageURL": LoadedChapatiComboSqure,
            "Name": "Loaded Chapati Combo",
            "category": "Breakfast Combos",
            "dec": "Our delicious chapatis served with sautéed spinach, 2 sausages & 2 farm fresh eggs with home fries and baked beans.",
            "KES": 1100,
            "RectImageURL": LoadedChapatiComboRect,
            "Upgrades": [
                { name: "ADD Fruit bowl", price: 180 },
                { name: "ADD Toast OR Chapati", price: 180 },
                { name: "Substitute home fries with Plantain", price: 330 },
                { name: "Substitute home fries with steamed vegetables", price: 330 },
                { name: "Substitute your juice with orange juice", price: 180 }
            ]
        },
        // new Addition CJ’s Chicken and Waffle
        {
            "ImageURL": CJChickenandWaffleSqure2025,
            "Name": "CJ’s Chicken and Waffle",
            "category": "Breakfast Combos",
            "dec": "Crispy fried chicken breast on a house made waffle with fried eggs served with home fries and a country gravy sauce.",
            "KES": 1100,
            "RectImageURL": CJChickenandWaffleRect2025,
            "Upgrades": [
                { name: "ADD Fruit bowl", price: 180 },
                { name: "ADD Toast OR Chapati", price: 180 },
                { name: "Substitute home fries with Plantain", price: 330 },
                { name: "Substitute home fries with steamed vegetables", price: 330 },
                { name: "Substitute your juice with orange juice", price: 180 }
            ]
        },

        // {
        //     "ImageURL": FriedChickenWafflesBenedictSquare,
        //     "Name": "Fried Chicken & Waffles Benedict",
        //     "category": "Breakfast Combos",
        //     "dec": "Our Belgian Waffle topped with crispy fried chicken strips, poached eggs and hollandaise. Served with maple syrup.",
        //     "KES": 1100,
        //     "RectImageURL": FriedChickenWafflesBenedictRect,
        //     "Upgrades": [
        //         { name: "ADD Fruit bowl", price: 180 },
        //         { name: "ADD Toast OR Chapati", price: 180 },
        //         { name: "Substitute home fries with Plantain", price: 330 },
        //         { name: "Substitute home fries with steamed vegetables", price: 330 },
        //         { name: "Substitute your juice with orange juice", price: 180 }
        //     ]
        // },

        // header and image updated Breakfast Pancake Sampler

        {
            "ImageURL": BreakfastSamplerSquare,
            "Name": "Breakfast Pancake Sampler",
            "category": "Breakfast Combos",
            "dec": "Two signature pancakes or chapatis, two farm fresh eggs, two sausages & baked beans served with home fries.",
            "KES": 1100,
            "RectImageURL": BreakfastSamplerRect,
            "Upgrades": [
                { name: "ADD Fruit bowl", price: 180 },
                { name: "ADD Toast OR Chapati", price: 180 },
                { name: "Substitute home fries with Plantain", price: 330 },
                { name: "Substitute home fries with steamed vegetables", price: 330 },
                { name: "Substitute your juice with orange juice", price: 180 }
            ]
        },
        // image updated Grilled Chicken & Eggs

        {
            "ImageURL": GrilledchickenSqaure,
            "Name": "Grilled Chicken & Eggs",
            "category": "Breakfast Combos",
            "dec": "Grilled chicken breasts, two farm fresh eggs served with golden brown home fries and toast.",
            "KES": 1100,
            "RectImageURL": GrilledchickenRect,
            "Upgrades": [
                { name: "ADD Fruit bowl", price: 180 },
                { name: "ADD Toast OR Chapati", price: 180 },
                { name: "Substitute home fries with Plantain", price: 330 },
                { name: "Substitute home fries with steamed vegetables", price: 330 },
                { name: "Substitute your juice with orange juice", price: 180 }
            ]
        },

        {
            "ImageURL": OmeletteComboSquare,
            "Name": "Omelette Combo",
            "category": "Breakfast Combos",
            "dec": "Chicken fajita omelette served with homefries.",
            "KES": 1100,
            "RectImageURL": OmeletteComboRect,
            "Upgrades": [
                { name: "ADD Fruit bowl", price: 180 },
                { name: "ADD Toast OR Chapati", price: 180 },
                { name: "Substitute home fries with Plantain", price: 330 },
                { name: "Substitute home fries with steamed vegetables", price: 330 },
                { name: "Substitute your juice with orange juice", price: 180 }
            ]
        },
        {
            "ImageURL": FitBreakfastSquare,
            "Name": "CJ’s Fit Breakfast",
            "category": "Breakfast Combos",
            "dec": "Grilled Chicken breast, Avocado, Poached Eggs, Steamed spinach, Roasted Plantain & Toast.",
            "KES": 1100,
            "RectImageURL": FitBreakfastReact,
            "Upgrades": [
                { name: "ADD Fruit bowl", price: 180 },
                { name: "ADD Toast OR Chapati", price: 180 },
                { name: "Substitute home fries with Plantain", price: 330 },
                { name: "Substitute home fries with steamed vegetables", price: 330 },
                { name: "Substitute your juice with orange juice", price: 180 }
            ]
        },
                // CJ’s House Breakfast

        {
            "ImageURL": HouseBreakfastSquare,
            "Name": "CJ’s House Breakfast",
            "category": "Breakfast Combos",
            "dec": "Two farm fresh eggs, sausages, beef macon, home fries, toast with butter and jam.",
            "KES": 1100,
            "RectImageURL": HouseBreakfastReact,
            "Upgrades": [
                { name: "ADD Fruit bowl", price: 180 },
                { name: "ADD Toast OR Chapati", price: 180 },
                { name: "Substitute home fries with Plantain", price: 330 },
                { name: "Substitute home fries with steamed vegetables", price: 330 },
                { name: "Substitute your juice with orange juice", price: 180 }
            ]
        },
        {
            "ImageURL": ChickenEggWrapComboSquare,
            "Name": "Chicken & Egg Wrap Combo",
            "category": "Breakfast Combos",
            "dec": "Grilled chicken, farm fresh eggs, cheese and fresh tomato wrapped in a home-made tortilla served with a fruit bowl, salsa and home fries.",
            "KES": 1100,
            "RectImageURL": ChickenEggWrapComboRect,
            "Upgrades": [
                { name: "ADD Fruit bowl", price: 180 },
                { name: "ADD Toast OR Chapati", price: 180 },
                { name: "Substitute home fries with Plantain", price: 330 },
                { name: "Substitute home fries with steamed vegetables", price: 330 },
                { name: "Substitute your juice with orange juice", price: 180 }
            ]
        },
        {
            "ImageURL": MonteCristoSandwichSquare,
            "Name": "CJ’s Monte Cristo Sandwich",
            "category": "Breakfast Combos",
            "dec": "Roasted turkey ham, cheese slices, mustard & cranberry sauce in a Brioche bread. Served with home fries.",
            "KES": 1100,
            "RectImageURL": MonteCristoSandwichRect,
            "Upgrades": [
                { name: "ADD Fruit bowl", price: 180 },
                { name: "ADD Toast OR Chapati", price: 180 },
                { name: "Substitute home fries with Plantain", price: 330 },
                { name: "Substitute home fries with steamed vegetables", price: 330 },
                { name: "Substitute your juice with orange juice", price: 180 }
            ]
        },
        {
            "ImageURL": ChickenSaladFilledCroissantComboSquare,
            "Name": "Chicken Salad-Filled-Croissant Combo",
            "category": "Breakfast Combos",
            "dec": "Generously filled croissant with chicken salad, mayo and cheese. Served with home fries, mixed salad, avocado and a fruit bowl.",
            "KES": 1100,
            "RectImageURL": ChickenSaladFilledCroissantComboReact,
            "Upgrades": [
                { name: "ADD Fruit bowl", price: 180 },
                { name: "ADD Toast OR Chapati", price: 180 },
                { name: "Substitute home fries with Plantain", price: 330 },
                { name: "Substitute home fries with steamed vegetables", price: 330 },
                { name: "Substitute your juice with orange juice", price: 180 }
            ]
        },
        // new Addition Roasted Chicken & Egg Breakfast Combo
        {
            "ImageURL": RoastedChickenEggBreakfastComboSqure,
            "Name": "Roasted Chicken & Egg Breakfast Combo",
            "category": "Breakfast Combos",
            "dec": "Oven roasted chicken on the bone, coleslaw salad, fried eggs, baked beans and home fries.",
            "KES": 1100,
            "RectImageURL": RoastedChickenEggBreakfastComboRect,
            "Upgrades": [
                { name: "ADD Fruit bowl", price: 180 },
                { name: "ADD Toast OR Chapati", price: 180 },
                { name: "Substitute home fries with Plantain", price: 330 },
                { name: "Substitute home fries with steamed vegetables", price: 330 },
                { name: "Substitute your juice with orange juice", price: 180 }
            ]
        },
        {
            "ImageURL": SteakAndEggsBreakfastSqure,
            "Name": "Steak and Eggs Breakfast",
            "category": "Breakfast Combos",
            "dec": "Two farm fresh eggs, beef steak, home fries, chapati and baked beans.",
            "KES": 1100,
            "RectImageURL": SteakAndEggsBreakfastSqure,
            "Upgrades": [
                { name: "ADD Fruit bowl", price: 180 },
                { name: "ADD Toast OR Chapati", price: 180 },
                { name: "Substitute home fries with Plantain", price: 330 },
                { name: "Substitute home fries with steamed vegetables", price: 330 },
                { name: "Substitute your juice with orange juice", price: 180 }
            ]
        },
        {
            "ImageURL": SalmonEggsAvocadoBenedictSqure,
            "Name": "Salmon, Eggs & Avocado Benedict",
            "category": "Breakfast Combos",
            "dec": "A delightful twist on the classic: poached egg, creamy avocado, and salmon on toasted bread, finished with a rich, velvety hollandaise sauce. Served with fruit salad.",
            "KES": 1100,
            "RectImageURL": SalmonEggsAvocadoBenedictSqure,
            "Upgrades": [
                { name: "ADD Fruit bowl", price: 180 },
                { name: "ADD Toast OR Chapati", price: 180 },
                { name: "Substitute home fries with Plantain", price: 330 },
                { name: "Substitute home fries with steamed vegetables", price: 330 },
                { name: "Substitute your juice with orange juice", price: 180 }
            ]
        },


        {
            "ImageURL": SpanishOmeletteSquare,
            "Name": "Spanish Omelette",
            "category": "Designer Omelettes",
            "dec": "Fresh tomatoes & onions.",
            "KES": 950,
            "RectImageURL": SpanishOmeletteRect,
            "Upgrades": [
                { name: "Fresh Diced Chicken", price: 330 },
                { name: "Home Fries", price: 180 },
                { name: "Fruit bowl", price: 180 },
                { name: "Fresh Veggies", price: 130 },
                { name: "Plantains", price: 330 },
                { name: "Avocado", price: 180 }
            ]
        },
        {
            "ImageURL": SpinachMushroomOmeletteSquare,
            "Name": "Spinach & Mushroom Omelette",
            "category": "Designer Omelettes",
            "dec": "Spinach, mushroom, Cheddar cheese topped with hollandaise sauce & diced tomatoes.",
            "KES": 950,
            "RectImageURL": SpinachMushroomOmeletteRect,
            "Upgrades": [
                { name: "Fresh Diced Chicken", price: 330 },
                { name: "Home Fries", price: 180 },
                { name: "Fruit bowl", price: 180 },
                { name: "Fresh Veggies", price: 130 },
                { name: "Plantains", price: 330 },
                { name: "Avocado", price: 180 }
            ]
        },
        {
            "ImageURL": ChickenFajitaOmeletteSquare,
            "Name": "Chicken Fajita Omelette",
            "category": "Designer Omelettes",
            "dec": "Spiced fajita chicken, onions, fresh green peppers, tomatoes & cheddar cheese.",
            "KES": 950,
            "RectImageURL": ChickenFajitaOmeletteRect,
            "Upgrades": [
                { name: "Fresh Diced Chicken", price: 330 },
                { name: "Home Fries", price: 180 },
                { name: "Fruit bowl", price: 180 },
                { name: "Fresh Veggies", price: 130 },
                { name: "Plantains", price: 330 },
                { name: "Avocado", price: 180 }
            ]
        },
        {
            "ImageURL": BelgianWaffleSquare,
            "Name": "Belgian Waffle",
            "category": "Waffle & Pancakes",
            "dec": "Golden Belgian waffle, topped with icing sugar and butter..",
            "KES": 800,
            "RectImageURL": BelgianWaffleRect,
            "Upgrades": [
                { name: "Add Ice cream or fruit Bowl", price: 180 },
                { name: "Add fresh strawberries", price: 180 },
                { name: "Add fresh banana slices", price: 130 }
            ]
        },
        {
            "ImageURL": StrawberryBananaWaffleSquare,
            "Name": "Strawberry & Banana Waffle",
            "category": "Waffle & Pancakes",
            "dec": "Belgian waffle topped with fresh strawberries and banana slices with a dollop of whipped cream.",
            "KES": 900,
            "RectImageURL": StrawberryBananaWaffleRect,
            "Upgrades": [
                { name: "Add Ice cream or fruit Bowl", price: 180 },
                { name: "Add fresh strawberries", price: 180 },
                { name: "Add fresh banana slices", price: 130 }
            ]
        },
        {
            "ImageURL": OriginalButtermilkPancakeSquare,
            "Name": "Original Buttermilk Pancake",
            "category": "Waffle & Pancakes",
            "dec": "Homely goodness of plain golden pancakes sprinkled with icing sugar and served with butter.",
            "KES": 800,
            "RectImageURL": OriginalButtermilkPancakeRect,
            "Upgrades": [
                { name: "Add Ice cream or fruit Bowl", price: 180 },
                { name: "Add fresh strawberries", price: 180 },
                { name: "Add fresh banana slices", price: 130 }
            ]
        },
        {
            "ImageURL": StrawberryBananaPancakeSquare,
            "Name": "Strawberry Banana Pancake",
            "category": "Waffle & Pancakes",
            "dec": "Buttermilk pancakes topped with banana slices, strawberries & a dollop of cream.",
            "KES": 900,
            "RectImageURL": StrawberryBananaPancakeRect,
            "Upgrades": [
                { name: "Add Ice cream or fruit Bowl", price: 180 },
                { name: "Add fresh strawberries", price: 180 },
                { name: "Add fresh banana slices", price: 130 }
            ]
        },
        {
            "ImageURL": bananaMuffin,
            "Name": "Banana Muffin",
            "category": "Amazing Muffins",
            "dec": "Delicious muffin flavored with fresh banana.",
            "KES": 300,
            "RectImageURL": bananaMuffinRect,
            "Upgrades": [
            ]
        },
        {
            "ImageURL": chocolateChipMuffin,
            "Name": "Chocolate Chip Muffin",
            "category": "Amazing Muffins",
            "dec": "Delicious muffin flavored with chocolate drops.",
            "KES": 300,
            "RectImageURL": chocolateChipMuffinRect,
            "Upgrades": [
            ]
        },
      
        {
            "ImageURL": chocolateMuffin,
            "Name": "Chocolate Muffin",
            "category": "Amazing Muffins",
            "dec": "Decadent chocolate muffins that are perfect for chocolate lovers.",
            "KES": 300,
            "RectImageURL": chocolateMuffinrect,
            "Upgrades": [
            ]
        },
        {
            "ImageURL": vanillaMuffin,
            "Name": "Vanilla Muffin",
            "category": "Amazing Muffins",
            "dec": "Delicious muffin flavored with vanilla.",
            "KES": 300,
            "RectImageURL": vanillaMuffinRect,
            "Upgrades": [
            ]
        },
        {
            "ImageURL": plainCroissand,
            "Name": "Plain Croissant",
            "category": "Baked Fresh Pastries",
            "dec": "A flaky plain croissant with a combination of butter, egg, sugar, milk & flour.",
            "KES": 310,
            "RectImageURL": plainCroissandRect,
            "Upgrades": [
            ]
        },
        {
            "ImageURL": almondCroissant,
            "Name": "Almond Croissant",
            "category": "Baked Fresh Pastries",
            "dec": "A flaky plain croissant with a combination of butter, egg, sugar, milk & flour flavored with almonds.",
            "KES": 350,
            "RectImageURL": almondCroissantRect,
            "Upgrades": [
            ]
        },
        {
            "ImageURL": chocolateTwist,
            "Name": "Chocolate Twist",
            "category": "Baked Fresh Pastries",
            "dec": "A creamy twisted flaky pastry with a combination of Butter, Egg, Sugar, milk & flour infused with chocolate.",
            "KES": 320,
            "RectImageURL": chocolateTwistRect,
            "Upgrades": [
            ]
        },
        {
            "ImageURL": CinnamonCroissant,
            "Name": "Cinnamon Croissant",
            "category": "Baked Fresh Pastries",
            "dec": "A creamy rolled flaky pastry with raisins & cinnamon's.",
            "KES": 310,
            "RectImageURL": CinnamonCroissantRect,
            "Upgrades": [
            ]
        },
        {
            "ImageURL": samosas,
            "Name": "Beef Samosas",
            "category": "Baked Fresh Pastries",
            "dec": "Beef Samosas.",
            "KES": 350,
            "RectImageURL": samosasRect,
            "Upgrades": []
        },
        {
            "ImageURL": ChickenSamosas,
            "Name": "Chicken Samosas",
            "category": "Baked Fresh Pastries",
            "dec": "Chicken Samosas.",
            "KES": 350,
            "RectImageURL": ChickenSamosasRect,
            "Upgrades": []
        },
        {
            "ImageURL": VegetableSamosas,
            "Name": "Vegetable Samosas",
            "category": "Baked Fresh Pastries",
            "dec": "Vegetable Samosas",
            "KES": 350,
            "RectImageURL": VegetableSamosasRect,
            "Upgrades": []
        },
        {
            "ImageURL": chickenSpringRolls,
            "Name": "Chicken Spring Rolls",
            "category": "Baked Fresh Pastries",
            "dec": "A pastry filled with chicken & vegetables served.",
            "KES": 400,
            "RectImageURL": chickenSpringRollsRect,
            "Upgrades": []
        },
        {
            "ImageURL": vegetableSpringRolls,
            "Name": "Vegetable Spring Rolls",
            "category": "Baked Fresh Pastries",
            "dec": "A pastry filled with stir-fried vegetables served.",
            "KES": 350,
            "RectImageURL": vegetableSpringRollsRect,
            "Upgrades": []
        },
        {
            "ImageURL": chickenPie,
            "Name": "Chicken Pie",
            "category": "Baked Fresh Pastries",
            "dec": "Chicken Pie",
            "KES": 350,
            "RectImageURL": chickenPieRect,
            "Upgrades": []
        },
        {
            "ImageURL": FruitSalad,
            "Name": "Fruit Salad",
            "category": "Fruitful Mornings",
            "dec": "Pineapple, watermelon, sweetmelon, mango, banana and paw paw unites in this juicy, delicious fruit salad cut into dices.",
            "KES": 700,
            "RectImageURL": FruitSaladRect,
            "Upgrades": [
                { name: "ADD Ice Cream", price: 0 },
                { name: "ADD Nuts", price: 150 },
                { name: "ADD Honey", price: 150 },
                { name: "ADD Yoghurt", price: 150 },
                { name: "ADD Strawberries", price: 180 }
            ]
        },
        {
            "ImageURL": TropicalBreakfast,
            // "ImageURL": FruitPlatter,
            "Name": "Tropical Breakfast",
            "category": "Fruitful Mornings",
            "dec": "An Assortment of fresh fruits with vanilla Yoghurt and honey toasted muesli.",
            "KES": 700,
            // "RectImageURL": TropicalBreakfastRect,
            "RectImageURL": TropicalBreakfastRect,

            "Upgrades": [
                { name: "ADD Nuts", price: 150 },
                { name: "ADD Honey", price: 150 },
                { name: "ADD Yoghurt", price: 150 },
            ]
        },
        {
            "ImageURL": FruitPlatter,
            "Name": "Fruit Platter",
            "category": "Fruitful Mornings",
            "dec": "A party sized platter consisting of large slices of pineapple, watermelon, sweet melon, pawpaw, mango & banana.",
            "KES": 700,
            "RectImageURL": FruitPlatterRect,
            "Upgrades": [

            ]
        },
        {
            "ImageURL": OatmealBreakfastSqure,
            "Name": "Oatmeal Breakfast",
            "category": "Fruitful Mornings",
            "dec": "A warm, creamy bowl of oats topped with banana, strawberry, raisins, nuts, honey, and a sprinkle of cinnamon. A wholesome, fiber-rich start to your day.",
            "KES": 700,
            "RectImageURL": OatmealBreakfastRect,
           
            "Upgrades": [
                { name: "ADD Nuts", price: 150 },
                { name: "ADD Honey", price: 150 },
                { name: "ADD Yoghurt", price: 150 },
            ]
        },
        {
            "ImageURL": SingleFriedEgg,
            "Name": "Single Fried Egg",
            "category": "Extras",
            "dec": "SINGLE FRIED EGG",
            "KES": 180,
            "RectImageURL": SingleFriedEggRectanle,
            "Upgrades": [

            ]
        },
        {
            "ImageURL": PairofSausages,
            "Name": "Pair of Sausages",
            "category": "Extras",
            "dec": "Pair of Sausages",
            "KES": 330,
            "RectImageURL": PairofSausagesRect,
            "Upgrades": [

            ]
        },
        {
            "ImageURL": HomeFries,
            "Name": "Home Fries",
            "category": "Extras",
            "dec": "Home Fries",
            "KES": 330,
            "RectImageURL": HomeFriesRect,
            "Upgrades": [

            ]
        },
        {
            "ImageURL": FruitBowl,
            "Name": "Fruit Bowl",
            "category": "Extras",
            "dec": "Fruit Bowl",
            "KES": 180,
            "RectImageURL": FruitBowlRect,
            "Upgrades": [

            ]
        },
        {
            "ImageURL": BakedBeans,
            "Name": "Baked Beans",
            "category": "Extras",
            "dec": "Baked Beans",
            "KES": 330,
            "RectImageURL": BakedBeansRect,
            "Upgrades": [

            ]
        },
        {
            "ImageURL": FriedPlantain,
            "Name": "Fried Plantain",
            "category": "Extras",
            "dec": "Deep fried sliced sweet gonjas.",
            "KES": 500,
            "RectImageURL": FriedPlantainRect,
            "Upgrades": [

            ]
        },
        {
        "ImageURL": roastedPlantain,
        "Name": "Roasted Plantain",
        "category": "Extras",
        "dec": "Roasted Plantain.",
        "KES": 500,
        "RectImageURL": roastedPlantainRect,
        "Upgrades": []
        },
        {
            "ImageURL": Toast,
            "Name": "Toast",
            "category": "Extras",
            "dec": "Toast",
            "KES": 180,
            "RectImageURL": ToastRect,
            "Upgrades": [

            ]
        },
        {
        "ImageURL": chapati,
        "RectImageURL": chapatiRect,
        "Name": "Chapati",
        "category": "Extras",
        "dec": "Chapati",
        "KES": 180,
        "Upgrades": [

        ]
        },
        {
            "ImageURL": BeefMacon,
            "Name": "Beef Macon",
            "category": "Extras",
            "dec": "Beef Macon",
            "KES": 330,
            "RectImageURL": BeefMaconRect,
            "Upgrades": [

            ]
        },
        {
            "ImageURL": Mushrooms,
            "Name": "Mushrooms",
            "category": "Extras",
            "dec": "Mushroom",
            "KES": 280,
            "RectImageURL": MushroomsRect,
            "Upgrades": [

            ]
        },
        {
            "ImageURL": Avocado,
            "Name": "Avocado",
            "category": "Extras",
            "dec": "Avocado",
            "KES": 180,
            "RectImageURL": AvocadoRect,
            "Upgrades": [

            ]
        },
        {
            "ImageURL": kiddieSampleCombo,
            "Name": "Kiddie Sampler Combo",
            "category": "Ranger Breakfast",
            "dec": "Pancake or chapati, fried egg, chicken strips, sausage & baked beans with your choice of fresh juice.",
            "KES": 880,
            "RectImageURL": kiddieSampleComboRect,
            "Upgrades": [

            ]
        },
        {
            "ImageURL": kiddieChapatiCombo,
            "Name": "Kiddie Chapati Combo",
            "category": "Ranger Breakfast",
            "dec": "Chapati, fried spinach, sausage, fried egg, and home fries with your choice of fresh juice.",
            "KES": 690,
            "RectImageURL": kiddieChapatiComboRect,
            "Upgrades": [

            ]
        },
        {
        "ImageURL": KiddiePancake,
        "RectImageURL": KiddiePancakeRect,
        "Name": "Kiddie Pancake",
        "category": "Ranger Breakfast",
        "dec": "Golden pancake with icing sugar, topping with frosting cream, banana and cherry.",
        "KES": 480,
        "Upgrades": [

        ]
        }


    ]

}


export default BigOnBreakfast;